export function getMailingListSubscriberMessage(
  email: string,
  pathname: string
) {
  return {
    blocks: [
      {
        type: 'context',
        elements: [
          {
            type: 'mrkdwn',
            text: `New mailing list subscriber: *${email}*`,
          },
          {
            type: 'mrkdwn',
            text: `Pathname: *${pathname}*`,
          },
        ],
      },
    ],
  };
}
